// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3v0VU","main":"Layout_main__1BI54"};